import { Breadcrumbs, Button, Typography } from "@mui/material";
import { Download } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { Admin_Parivartan_Get_All_States } from "../../../constants";
import axios from "axios";
import StateTableComponent from "./component/StateTableComponent";
import AddNewStateModal from "./component/AddNewStateModal";

const StateComponent = ({}) => {
  const handleBack = () => {};
  const [addNewStateModalOpen, setAddNewStateModalOpen] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchStateData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Admin_Parivartan_Get_All_States}`);
      const state = response.data.data || [];
      setStateList(state);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching role data:", error);
      return null; // Return null or empty array on error
    }
  };

  useEffect(() => {
    fetchStateData();
  }, []);

  const columns = [
    { headerName: "State ID", field: "StateCode" },
    { headerName: "State Name", field: "StateName" },
    { headerName: "Country Code", field: "CountryCode" },
  ];

  const fetchStateDataExport = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_All_States}`);
      const region = response.data.data || [];

      return region;
    } catch (error) {
      console.error("Error fetching role data:", error);
      return null;
    }
  };

  const handleExport = async () => {
    const data = await fetchStateDataExport();
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.field];

          return value || "";
        })
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "State_Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `state_data_${dayjs().format("YYYYMMDD")}.xlsx`);
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          State Master
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">State Master</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddNewStateModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New State
            </Button>

            <Button
              onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <StateTableComponent
          stateList={stateList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={fetchStateData}
        />

        <AddNewStateModal
          open={addNewStateModalOpen}
          onClose={() => setAddNewStateModalOpen(false)}
          onRefresh={fetchStateData}
        />
      </div>
    </>
  );
};

export default StateComponent;
